import { TechLogsValidationData } from '../../../integrated-client/models';

export interface IFormDataHistorical {
  historicalValidation: TechLogsValidationData | null
  correlationId: string | null
}

export class FormData implements IFormDataHistorical {
  historicalValidation: TechLogsValidationData | null
  correlationId: string | null

  constructor() {
    this.correlationId = null
    this.historicalValidation = null
  }
}
